import { isParticipant } from 'app/main/util/enums';

export const handleGetJobs = (dispatch, Actions, user) => {
    if (isParticipant(user)) return dispatch(Actions.getParticipantJobs());
    return dispatch(Actions.getJobs());
};

export const handleSubmitJob = (dispatch, Actions, user, jobId, clusterId, runAsAdmin) => {
    if (isParticipant(user)) return dispatch(Actions.participantSubmitJob(jobId, clusterId));
    return dispatch(Actions.submitJob(jobId, clusterId, runAsAdmin));
};

export const handleCancelJob = (dispatch, Actions, user, jobId, clusterId) => {
    if (isParticipant(user)) return dispatch(Actions.participantCancelJob(jobId, clusterId));
    return dispatch(Actions.cancelJob(jobId, clusterId));
};
